import SearchIcon from "@mui/icons-material/Search";

import React, { useEffect, useRef, useState } from "react";

import AddIcCallIcon from "@mui/icons-material/AddIcCall";

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Fab,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Divider,
  Tabs,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerShow,
  setMobileTableDrawer,
  setUpdateBillData,
} from "../app/store/reducer";
import "./table.css";
import { useNavigate } from "react-router";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { routePath } from "../constants/routePath";
import { displayDateFormat, payloadDateFormat } from "../utils/commonUtils";
import DateFormatter from "./timeFormatter";
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@emotion/react";
import { TextFieldSearch } from "./fieldText";
import PoprchModal from "../features/payment/popSearch";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import calendar from "../assets/icon/calendarblack.png";
import { getBillCounterSellPartPayment } from "../features/counterSell/counterSellApi";

const TableWithBox = ({
  data,
  billCount,
  billApiCall,
  paginationApiCall,
  changeState,
  setFilter,
  filter,
  callgetAllEmp,
  appoinmentId,
  setAppoinmentId,
  setBills,
  setBillCount,
}) => {
  const drawerShow = useSelector((state) => state.reducer.drawerShow);
  const dispatch = useDispatch();
  // const [search, setSearchvalue] = useState("");
  const [cardValue, setCardValue] = useState(null);
  const [searchVal, setSearchVal] = useState("");
  const [value, setValue] = React.useState("all");
  const [paidBills, setPaidBills] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [search, setSearchvalue] = useState("");

  // const [appoinmentId,setAppoinmentId]=useState("")

  const sumItemPrice = (item) => {
    let sum = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    item?.counterSalesChild?.forEach((item) => {
      sum +=
        item.amount +
        (item.amount * item.sgst) / 100 +
        (item.amount * item.igst) / 100 +
        (item.amount * item.cgst) / 100;
      cgst += (item.amount * item.cgst) / 100;
      sgst += (item.amount * item.sgst) / 100;
      igst += (item.amount * item.igst) / 100;
    });
    return {
      sum: sum,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
    };
  };

  const payableValueCalculate = (billData) => {
    let sum = sumItemPrice(billData).sum;
    console.log("payableValueCalculate sum ", sum);
    let discountPrice = (billData?.discount / 100) * sum;
    console.log("payableValueCalculate discountPrice ", billData?.discount);

    if (billData?.discountType === "Percent") {
      console.log(
        "payableValueCalculate sum - discountPrice ",
        sum - discountPrice,
      );

      return sum - discountPrice;
    } else {
      console.log(
        "payableValueCalculate  sum - billData?.discount ",
        sum - billData?.discount,
      );

      return sum - billData?.discount;
    }
  };

  const [pageNo, setPageNo] = useState(1);
  const [startDate, setStartDate] = useState(dayjs());
  const [SelectedStartDate, setSelectedStartDate] = useState("");
  useEffect(() => {
    console.log("callgetAllEmp", callgetAllEmp);
    if (callgetAllEmp) {
      callgetAllEmp({
        page: pageNo,

        status: "",
        filter: filter,
        search: String(search?.id),
        date: date,

        pageSize: 10,
      });
    }
  }, [search, filter]);
  const getSearchValue = () => {
    if (searchVal) return searchVal; // payment mode selected
    if (value === "Credit") return "Credit";
    if (value === "paid") return "paid";
    return "";
  };
  useEffect(() => {
    const payload = {
      date: date,
      status: "",
      filter: "partpayment",
      search: getSearchValue(),
      page: 1,
      pageSize: 10,
    };

    getBillCounterSellPartPayment(payload, (res) => {
      const data = res?.data?.data?.counterSalesHeader;
      setBillCount({
        ...billCount,
        totalBills: res?.data?.data?.totalBills,
        totalOutstanding: res?.data?.data?.totalOutstanding,
        totalSales: res?.data?.data?.totalSales,
        unpaidBills: res?.data?.data?.unpaidBills,
      });
      setBills(data);
    });
  }, [searchVal, value]);
  const [date, setDate] = useState(
    (() => {
      function addLeadingZero(value) {
        return value < 10 ? "0" + value : value;
      }
      var currentDate = new Date();

      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1;
      var day = currentDate.getDate();
      var formattedDate =
        year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

      return formattedDate;
    })(),
  );

 const handleChange = (event, newValue) => {
   setPageNo(1);
   setValue(newValue);

   if (newValue === "all") {
     paginationApiCall(date, 1, "", "");
   }

   if (newValue === "Credit") {
     paginationApiCall(date, 1, "Credit", "partpayment");
   }

   if (newValue === "paid") {
     paginationApiCall(date, 1, "paid", "partpayment");
   }
 };
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const navigate = useNavigate();
  const mobileTableDrawer = useSelector(
    (state) => state.reducer.mobileTableDrawer,
  );

  const theme = useTheme();

  // const AmountColorSet = (item) => {
  //   if (
  //     item?.paymentMode === "Credit" &&
  //     item?.billStatus !== "Unpaid"
  //     // item?.billDate?.split("T")[0] == payloadDateFormat()
  //   ) {
  //     return "yellow";
  //   }
  //   if (
  //     item?.paymentMode === "Credit" &&
  //     item?.billStatus === "Unpaid"
  //     // item?.billDate?.split("T")[0] == payloadDateFormat()
  //   ) {
  //     return "orange";
  //   }
  //   if (item?.paymentMode === "Credit") {
  //     return "orange";
  //   } else {
  //     return "yellow";
  //   }
  // };

  const AmountColorSet = (item) => {
    if (
      item?.paymentMode === "Credit" &&
      item?.billStatus != "Paid"

      // item?.billDate?.split("T")[0] == payloadDateFormat()
    ) {
      return "red";
    }
    if (
      item?.paymentMode === "Credit" &&
      item?.billStatus == "Paid"

      // item?.billDate?.split("T")[0] == payloadDateFormat()
    ) {
      return "orange";
    }
    if (item?.paymentMode === "Cash") {
      return "green";
    }
    if (item?.paymentMode === "Digital") {
      return "green";
    }
    return null;
    // else {
    //   return "yellow";
    // }
  };

  useEffect(() => {
    if (drawerShow && startDate) {
      const formattedDate = dayjs(startDate).format("YYYY-MM-DD");
      billApiCall(formattedDate);
    }
  }, [drawerShow]);

  const addAllValue = (arr) => {
    let amount = 0;
    arr.forEach((item) => {
      amount += item.amount;
    });
    return amount;
  };
  const addAllAmount = (billData) => {
    let add = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let payableAmount = 0;
    let allAmount = addAllValue(billData.counterSalesChild ?? []);
    let discountDivVal = 0;
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount; //170/10=17

    if (billData.discountType == "Amount") {
      divideVal = allAmount / billData.discount;
    }
    if (billData.discountType != "Amount") {
      let per = (allAmount * billData.discount) / 100;
      divideVal = allAmount / per;
    }
    billData?.counterSalesChild?.forEach((item) => {
      let subVal = item.amount / divideVal; //40/17
      let afterCalculation = 0;
      if (billData.discount) {
        afterCalculation = item.amount - subVal;
      } else {
        afterCalculation = item.amount;
      }
      console.log("afterCalculation ", afterCalculation);
      add += afterCalculation;
      cgst += (afterCalculation * (item.cgst ?? 1)) / 100;
      igst += (afterCalculation * (item.igst ?? 1)) / 100;
      sgst += (afterCalculation * (item.sgst ?? 1)) / 100;
    });

    return {
      sum: add,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      payableAmount: (add + cgst + sgst + igst)?.toFixed(2),
    };
  };
  const billerMenuseletec = useSelector(
    (state) => state.reducer.billerMenuseletec,
  );

  const paymentOptions = [
    { value: "", label: "All" },
    { value: "Cash", label: "Cash Payment" },
    { value: "UPI", label: "UPI" },
    { value: "CardPay", label: "Card Payment" },
    { value: "Credit", label: "Credit (balance)" },
    { value: "Cheque", label: "Cheque" },
    { value: "NetBanking", label: "Net Banking" },
    { value: "PCR", label: "PCR" },
    { value: "Wallet", label: "Wallet" },
    { value: "OtherPay", label: "Other Payment Mode" },
  ];

  const getBillColor = (item) => {
    if (item.billStatus === "Paid" && item.paymentMode === "Credit") {
      return "#FFFDE7";
    }

    if (
      item.billStatus === "Paid" &&
      // businessLineCode === "RE" &&
      !item.settleBill
    ) {
      return "#FFFEE9";
    }

    if (item.billStatus === "Paid") {
      return "#F0EDFF";
    }

    if (item.billStatus === "Unpaid") {
      return "#FFD5D7";
    }

    if (item.billStatus === "Partially Paid") {
      return "#FFFEE9";
    }

    return "#F0EDFF";
  };
  const getTextColor = (item) => {
    if (!item?.paymentMode) return "#000";

    if (item.billStatus === "Paid" && item.paymentMode === "Credit") {
      return "#ED8620"; // yellow_900
    }

    if (item.billStatus === "Paid") {
      return "#1B5E20"; // green_900
    }

    if (item.billStatus === "Unpaid") {
      return "#97161D"; // red_900
    }

    if (item.billStatus === "Partially Paid") {
      return "#ED8620"; // yellow_900
    }

    return "#000";
  };
  const getTextColorAll = (item) => {
    if (!item?.paymentMode) return "#000";

    if (item.billStatus === "Paid" && item.paymentMode === "Credit") {
      return "#ED8620"; // yellow_900
    }

    if (item.billStatus === "Paid") {
      return "#0C0C6A";
    }

    if (item.billStatus === "Unpaid") {
      return "#97161D"; // red_900
    }

    if (item.billStatus === "Partially Paid") {
      return "#ED8620"; // yellow_900
    }

    return "#000";
  };
  return (
    <>
      {billerMenuseletec == 0 && (
        <Box sx={{ width: "100%", textAlign: "right", my: 3 }}>
          <Fab
            onClick={() => changeState(true)}
            sx={{
              textTransform: "capitalize",
              width: {
                xs: "100%",
                sm: "auto",
              },
              // p: "10px",
              whiteSpace: "nowrap",
              zIndex: "0",
            }}
            size="small"
            color="primary"
            variant="extended"
            aria-label="add"
          >
            Add new bill
            <AddIcon />
          </Fab>
        </Box>
      )}
      {billerMenuseletec == 1 && (
        <Box
          component={Paper}
          sx={{
            width: "100%",
            display: "block",
            m: "0px",
            borderRadius: "10px",
            height: "calc(100vh - 64px)",
          }}
        >
          <Grid container>
            {/* <Grid
              item
              xs={12}
              sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                padding: "8px 16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              <Box
                component={"h3"}
                sx={{ flex: 4, color: (theme) => theme.palette.primary.main }}
              >
                Bills
              </Box>
            </Grid> */}

            <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="transparent"
                  aria-label="primary tabs example"
                  sx={{
                    // width: "100%",
                    "& .MuiTabs-flexContainer": {
                      justifyContent: "space-between",
                    },
                    // padding: "10px 1px 5px",
                    px: { xs: "1px", sm: "10px" },
                    py: { sm: "10px", xs: "5px" },
                  }}
                >
                  <Tab
                    value="all"
                    label="All bills"
                    // onClick={() => {
                    //   setPaidBills("");
                    //   paginationApiCall(date, pageNo, "");
                    // }}
                    sx={{
                      fontWeight: value === "all" ? "500" : "",
                      backgroundColor:
                        value === "all" ? "primary.main" : "#fff",
                      borderRadius: "10px",
                      width: { lg: "fit-content", xl: "100%" },
                      color: value === "all" ? "#fff" : "primary.main",
                      "&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "primary.main",
                      },
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  />
                  <Tab
                    value="Credit"
                    label="Credit Bills"
                    // onClick={(e) => {
                    //   setPaidBills("");
                    //   paginationApiCall(date, pageNo, "Credit", "partpayment");
                    // }}
                    sx={{
                      fontWeight: value === "credit" ? "500" : "",
                      backgroundColor:
                        value === "credit" ? "primary.main" : "#fff",
                      borderRadius: "10px",
                      width: { lg: "fit-content", xl: "100%" },
                      color: value === "credit" ? "#fff" : "primary.main",
                      "&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "primary.main",
                      },
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  />
                  <Tab
                    value="paid"
                    label="Paid Bills"
                    // onClick={() => {
                    //   paginationApiCall(date, pageNo, "paid", "partpayment");
                    // }}
                    sx={{
                      fontWeight: value === "paid" ? "500" : "",
                      backgroundColor:
                        value === "paid" ? "primary.main" : "#fff",
                      borderRadius: "10px",
                      width: { lg: "fit-content", xl: "100%" },
                      color: value === "paid" ? "#fff" : "primary.main",
                      "&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "primary.main",
                      },
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  />
                </Tabs>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                borderTop: "1px solid #958E8E",
                // padding: "8px 16px",
                py: "8px",
                px: { xs: "10px", sm: "16px" },
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date"
                      value={startDate ? dayjs(startDate) : null}
                      onChange={(newValue) => {
                        if (!newValue) return;
                        // Format date as YYYY-MM-DD
                        const formattedDate = newValue.format("YYYY-MM-DD");
                        setDate(formattedDate);
                        billApiCall(formattedDate);
                        setStartDate(newValue);
                        setPageNo(1);
                        setValue("all");
                        setPaidBills("cash");
                      }}
                      format="DD-MM-YYYY"
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          InputLabelProps: {
                            shrink: true, // ✅ prevents outline cutting label
                          },
                          placeholder: "Date",
                          InputProps: {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end">
                                  <Box
                                    component="img"
                                    src={calendar}
                                    alt="calendar icon"
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                            sx: {
                              background: "#fff",
                              borderRadius: 1,
                              height: "50px",
                            },
                          },
                          sx: {
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "primary.main",
                                borderWidth: "2px",
                              },
                            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "primary.main",
                                borderWidth: "2px",
                              },
                            "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "primary.main",
                                borderWidth: "2px",
                              },
                            height: "50px",
                          },
                        },
                        openPickerIcon: {
                          sx: { color: "#000" },
                        },
                      }}
                      maxDate={dayjs()}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink={true} id="payment-mode-label">
                      Filter By
                    </InputLabel>

                    <Select
                      sx={{
                        height: "50px",
                        width: "100%",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      labelId="tags-label"
                      id="services"
                      name="tags"
                      value={filter}
                      onChange={(e) => {
                        setSearchvalue("");
                        setFilter(e.target.value);
                      }}
                      input={
                        <OutlinedInput
                          label="Filter By"
                          notched={true}
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        />
                      }
                    >
                      {/* <MenuItem value={"null"}>
                      <ListItemText primary={"Filter"} />
                    </MenuItem> */}
                      <MenuItem
                        value={"employeemasterid"}
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        <ListItemText
                          primary={"Employee Name"}
                          primaryTypographyProps={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            fontFamily: "Montserrat",
                          }}
                        />
                      </MenuItem>
                      <MenuItem
                        value={"appointmentId"}
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        <ListItemText
                          primary={"Appointment id"}
                          primaryTypographyProps={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            fontFamily: "Montserrat",
                          }}
                        />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  {filter == "appointmentId" && (
                    <TextField
                      fullWidth
                      id="appoinmentId"
                      label="Appoinment Id"
                      value={appoinmentId}
                      onChange={(e) => {
                        setDate("");
                        setStartDate("");
                        setAppoinmentId(e.target.value);
                      }}
                      sx={{
                        textAlign: "center",
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "primary.main",
                            borderWidth: "2px",
                          },
                        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "primary.main",
                            borderWidth: "2px",
                          },
                        "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "primary.main",
                            borderWidth: "2px",
                          },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: { height: "50px" },
                        endAdornment: (
                          <SearchIcon
                            onClick={() => {
                              callgetAllEmp({
                                page: pageNo,

                                status: "",
                                filter: filter == "null" ? "" : filter,
                                search: appoinmentId,
                                date: date,

                                pageSize: 10,
                              });
                            }}
                            sx={{
                              cursor: "pointer",
                              color: (theme) => theme.palette.primary.main,
                            }}
                          />
                        ),
                      }}
                    />
                  )}

                  {filter == "employeemasterid" && (
                    <>
                      <TextFieldSearch
                        search={search?.name}
                        label="Search"
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        setOpen={setSearchModal}
                        from="previousBilling"
                      />
                      <PoprchModal
                        cardValue={cardValue}
                        setCardValue={(data) => {
                          setSearchvalue(data);

                          setCardValue(data);

                          if (drawerShow && startDate) {
                            const formattedDate =
                              dayjs(startDate).format("YYYY-MM-DD");
                            billApiCall(formattedDate, {
                              filter: "employeemasterid",
                              search: String(search?.id),
                            });
                          }
                        }}
                        callback={() => {}}
                        searchModal={searchModal}
                        setSearchModal={setSearchModal}
                      />
                    </>
                  )}
                </Grid>

                {/* ..New Add Filter partpeyment */}
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink={true} id="payment-mode-label">
                      Payment Mode
                    </InputLabel>

                    <Select
                      labelId="payment-mode-label"
                      id="services"
                      name="tags"
                      value={searchVal}
                      label="Payment Mode"
                      displayEmpty
                      onChange={(e) => {
                        setSearchVal(e.target.value);
                      }}
                      input={
                        <OutlinedInput
                          label="Payment Mode"
                          notched={true}
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        />
                      }
                      sx={{
                        height: "50px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                        },
                      }}
                      renderValue={(selected) => {
                        const selectedOption = paymentOptions.find(
                          (option) => option.value === selected,
                        );
                        return selectedOption ? selectedOption.label : "All";
                      }}
                    >
                      {paymentOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <ListItemText
                            primary={option.label}
                            primaryTypographyProps={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              fontFamily: "Montserrat",
                            }}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            {/* const [filter, setFilter] = React.useState(""); // Initialize with empty string */}

            {/* Online  cash payment radio */}
            {/* {value === "paid" && (
              <Grid item xs={12}>
                <RadioGroup
                  row
                  sx={{
                    display: "flex",
                    gap: { sm: 20, xs: 2 },
                    justifyContent: "center",
                    fontWeight: "500",
                    width: "100%",
                  }}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={paidBills}
                  onChange={(e) => {
                    paginationApiCall(date, pageNo, e.target.value, "paid");
                    // paginationApiCall(date, pageNo, "paid", e.target.value);
                    setPaidBills(e.target.value);
                    // setBill({

                    //   ...bill,
                    //   paymentMode: e.target.value,
                    // });
                  }}
                >
                  <FormControlLabel
                    value="cash"
                    control={<Radio sx={{ color: "primary.main" }} />}
                    label={
                      <Box
                        sx={{
                          fontWeight: 600,
                          color: "primary.main",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Cash Payment
                      </Box>
                    }
                  />
                  <FormControlLabel
                    value="digital"
                    control={<Radio sx={{ color: "primary.main" }} />}
                    label={
                      <Box
                        sx={{
                          fontWeight: 600,
                          color: "primary.main",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Online Payment
                      </Box>
                    }
                  />
                </RadioGroup>
              </Grid>
            )} */}

            <Grid
              item
              xs={12}
              sx={{
                padding: "8px 16px",
                fontWeight: "500",
              }}
            >
              <Grid container>
                <Grid
                  item
                  xs={"auto"}
                  sx={{
                    padding: "16px",
                    margin: "8px 8px 0px 0",
                    backgroundColor: "#CCCCFF",
                    borderRadius: "11px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      fontWeight: 500,
                      color: "#01008B",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Total Sale:
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      fontWeight: 600,
                      color: "#01008B",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    <CurrencyRupeeIcon
                      sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                    />
                    {billCount?.totalSales?.toFixed(2)}{" "}
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={"auto"}
                  sx={{
                    padding: "16px",
                    margin: "8px 8px 0px 0",
                    backgroundColor: "#CCCCFF",
                    borderRadius: "11px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      fontWeight: 500,
                      color: "#01008B",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Total Bills:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      fontWeight: 600,
                      color: "#01008B",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {/* <CurrencyRupeeIcon
                      sx={{ fontSize: "18px" }}
                    /> */}
                    {billCount?.totalBills}{" "}
                  </Box>
                </Grid>

                {value !== "paid" && value !== "credit" && (
                  <Grid
                    item
                    xs={"auto"}
                    sx={{
                      padding: "16px",
                      margin: "8px 8px 0px 0",
                      backgroundColor: "#CCCCFF",
                      borderRadius: "11px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        marginLeft: "8px",
                        fontWeight: 500,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Outstanding:
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        marginLeft: "8px",
                        fontWeight: 600,
                        color: "#01008B",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      <CurrencyRupeeIcon
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      />
                      {billCount?.totalOutstanding?.toFixed(2)}
                    </Box>
                  </Grid>
                )}

                {value !== "paid" && value !== "credit" && (
                  <Grid
                    item
                    xs={"auto"}
                    sx={{
                      padding: "16px",
                      margin: "8px 8px 0px 0",
                      backgroundColor: "#CCCCFF",
                      borderRadius: "11px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        marginLeft: "8px",
                        fontWeight: 500,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Unpaid Bills:
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        marginLeft: "8px",
                        fontWeight: 600,
                        color: "#01008B",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {/* <CurrencyRupeeIcon
                        sx={{ fontSize: "18px" }}
                      /> */}
                      {billCount?.unpaidBills}
                    </Box>
                  </Grid>
                )}
              </Grid>
              {/* <Box>
                <Box
                  component="span"
                  sx={{ color: (theme) => theme.palette.primary.main }}
                >
                  Total Sale:
                </Box>
                <Box
                  component="span"
                  sx={{
                    fontWeight: "500",
                    // display: "flex",
                    // justifyContent: "right",
                    // alignItems: "center",
                    color: (theme) => theme.palette.secondary.main,
                  }}
                >
                  <CurrencyRupeeIcon
                    sx={{ height: "17px", marginBottom: "-2px" }}
                  />
                  {billCount?.totalSales?.toFixed(2)}{" "}
                </Box>
              </Box> */}

              {/* {value !== "paid" && value !== "credit" && (
                <Box>
                  <Box
                    component="span"
                    sx={{ color: (theme) => theme.palette.primary.main }}
                  >
                    Outstanding:
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      color: (theme) => theme.palette.secondary.main,
                    }}
                  >
                    <CurrencyRupeeIcon
                      sx={{ height: "17px", marginBottom: "-2px" }}
                    />
                    {billCount?.totalOutstanding?.toFixed(2)}
                  </Box>
                </Box>
              )} */}
            </Grid>

            {/* <Grid
              item
              xs={6}
              sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                padding: "8px 16px",
                fontWeight: "500",
              }}
            >
              <Box sx={{ flex: 4 }}>
                <Box
                  component={"span"}
                  sx={{ color: (theme) => theme.palette.primary.main }}
                >
                  Total Bills:{" "}
                </Box>
                <Box
                  component={"span"}
                  sx={{
                    marginLeft: "8px",
                    color: (theme) => theme.palette.secondary.main,
                  }}
                >
                  {billCount?.totalBills}{" "}
                </Box>
              </Box>
              {value !== "paid" && value !== "credit" && (
                <Box
                  sx={{
                    flex: 4,
                    color: (theme) => theme.palette.primary.main,
                  }}
                >
                  <Box component="span">Unpaid Bills: </Box>
                  <Box
                    component="span"
                    sx={{
                      marginLeft: "8px",
                      color: (theme) => theme.palette.secondary.main,
                    }}
                  >
                    {billCount?.unpaidBills}
                  </Box>
                </Box>
              )}
            </Grid> */}
          </Grid>

          <Box container>
            <Grid
              item
              xs={12}
              sx={{
                borderColor: "divider",
              }}
            >
              <Grid container sx={{ paddingX: "20px", paddingY: "10px" }}>
                <Grid item xs={2} sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Bill No.
                  </Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Customer Name
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Time
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Total
                  </Typography>
                </Grid>
              </Grid>
              {/* <Divider sx={{ color:"#000", borderWidth:"2px" }}/> */}
            </Grid>
            <Grid container sx={{ borderTop: "1px solid #958E8E" }}>
              <Grid
                item
                xs={12}
                sx={{
                  // marginRight: "20px",
                  paddingRight: "20px",
                  paddingLeft: "20px",
                  marginY: "10px",
                  overflowY: "auto",
                  height: "40vh",
                }}
              >
                <Grid container>
                  {data.map((item) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        onClick={() => {
                          dispatch(setUpdateBillData(item));
                          navigate(routePath.UPDATEBILLS);
                          dispatch(setDrawerShow(false));
                        }}
                        sx={{
                          cursor: "pointer",
                          borderRadius: "10px",
                          boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.25)",
                          padding: "10px",
                          backgroundColor: getBillColor(item),

                          marginBottom: "10px",
                        }}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              textAlign: "center",
                              color: "primary.main",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              color: getTextColorAll(item),
                              fontWeight: 600,
                            }}
                          >
                            {item.billNumber}
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sx={{
                              textAlign: "center",
                              color: "#000",
                              fontWeight: 600,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              color: getTextColorAll(item),
                            }}
                          >
                            {item.customer}
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{
                              textAlign: "center",
                              color: "#000",
                              fontWeight: 600,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              color: getTextColorAll(item),
                            }}
                          >
                            <DateFormatter dateString={item.billDate} />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{
                              fontWeight: 600,
                              color: "#000",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              color: getTextColor(item),
                            }}
                          >
                            <CurrencyRupeeIcon
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            />
                            {(item.billAmount ?? 0).toFixed(2)}
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
            {/* <Box
              sx={{
                overflowY: "auto",
                height: "30vh",
              }}
            >
              {data.map((item) => {
                // if (item.paymentMode !== value && value !== "all") {
                //   return null;
                // }
                return (
                  <Box
                    key={item.id}
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                      display: "flex",
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      padding: "8px 16px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch(setUpdateBillData(item));
                      navigate(routePath.UPDATEBILLS);
                      dispatch(setDrawerShow(false));
                    }}
                  >
                    <Box sx={{ flex: 1, fontWeight: "500" }}>
                      {item.billNumber}
                    </Box>
                    <Box
                      sx={{
                        flex: 2,
                        fontWeight: "500",
                      }}
                    >
                      {item.customer}
                    </Box>
                    <Box
                      sx={{
                        flex: 2,
                        fontWeight: "500",
                      }}
                    >
                      <DateFormatter dateString={item.billDate} />
                    </Box>
                    <Box
                      sx={{
                        flex: 2,
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        color: AmountColorSet(item),
                      }}
                    >
                      <CurrencyRupeeIcon sx={{ height: "17px" }} />{" "}
                      {(item.billAmount ?? 0).toFixed(2)}
                    </Box>
                  </Box>
                );
              })}
            </Box> */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Pagination
                count={
                  Number.isInteger(billCount?.totalBills / 10)
                    ? billCount?.totalBills / 10
                    : parseInt(billCount?.totalBills / 10) + 1
                }
                page={pageNo}
                onChange={(e, v) => {
                  console.log("value ", value);
                  if (value === "all") {
                    paginationApiCall(date, v, "null");
                  } else if (value == "paid") {
                    paginationApiCall(date, pageNo, paidBills, "paid");
                  } else {
                    paginationApiCall(date, v, value);
                  }
                  setPageNo(v);
                }}
                shape="rounded"
              />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TableWithBox;
